import { createContext, useContext } from 'react';

import type { QUESTION_IDS_TYPE } from 'bundles/onboarding-common/constants/questionScheme';

export type OnboardingProgressContextType = {
  /**
   * The current step of the onboarding process starting from 1
   */
  currentStep: number;
  /**
   * The current question id
   */
  questionId: QUESTION_IDS_TYPE | null;
  /**
   * The list of question ids that are part of the onboarding process
   */
  questionIds: QUESTION_IDS_TYPE[];
  /**
   * The total number of steps in the onboarding process (questionIds.length)
   */
  totalSteps: number;
  /**
   * Set the current question id
   */
  setQuestionId: (questionId: QUESTION_IDS_TYPE) => void;
};

const OnboardingProgressContext = createContext<OnboardingProgressContextType | null>(null);

export const useOnboardingProgress = () => {
  const context = useContext(OnboardingProgressContext);

  if (!context) {
    throw new Error('useOnboardingProgress must be used within a OnboardingProgressProvider');
  }

  const { currentStep, questionId, questionIds, totalSteps, setQuestionId } = context;

  return {
    currentStep,
    questionId,
    totalSteps,
    questionIds,
    setQuestionId,
  };
};

export default OnboardingProgressContext;
